// polyfills
import '@babel/polyfill';
// styles
import '../scss/style.scss';
// imports
import './_imports';

import 'simplebar'; // or "import SimpleBar from 'simplebar';" if you want to use it manually.
import 'simplebar/dist/simplebar.css';

document.addEventListener('DOMContentLoaded', () => {
  const resize = () => {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`)
  }
  resize()

  window.addEventListener('resize', resize)
})
